module.exports = __webpack_public_path__ + "img/arrow-up.9c51d39a.svg";